import { IconButton } from "@mui/material";

import DoubleCheckingButton from "@Layouts/components/Buttons/DoubleCheckingButton";

import TrashIcon from "@/assets/icons/motivators/spiffSetup/trash-white.svg";

type IRemoveAssignmentProps = {
	visible: boolean;
	disabled: boolean;
	onDeleteAction: () => void;
};

export const RemoveAssignment = ({ visible = true, disabled = false, onDeleteAction }: IRemoveAssignmentProps) =>
	visible ? (
		<DoubleCheckingButton
			title="Remove"
			onDeleteAction={onDeleteAction}
			mainButtonClasses="!ml-[-50px]"
			confirmationButtonClasses="ml-1"
			disabled={disabled}
			endIcon={
				<IconButton>
					<img src={TrashIcon} alt="trash" className="w-[13.5px] h-[14.5px]" />
				</IconButton>
			}
		/>
	) : null;
